import * as React from "react"

/** True when the main panel is rendered inside the shadcn `SidebarInset` (sidebar-07) shell. */
export const ShadcnInsetChromeContext = React.createContext(false)

export function useShadcnInsetChrome() {
  return React.useContext(ShadcnInsetChromeContext)
}
